import React from "react";
import {formatDate, formatPhoneNumberForDisplay, formatTime, hourMinuteOnly} from "../../../../../util/helpers";
import {conversationName} from "../../../../../util/whatsappProfile";
import MyAvatar from "../../../Conversation/MyAvatar";
import IntlMessages from "../../../../../util/IntlMessages";
import PropTypes from "prop-types";


const UserCell = ({chat, selectedChatId, onSelectUser, isUnread}) => {

  const getLastMessageShort = (lastMessage) => {
    if (lastMessage) {
      if (lastMessage.channel === 'system') {
        return <IntlMessages id={lastMessage.body}/>
      }
      return lastMessage.body && lastMessage.body.substring(0, 25) + "..."
    }
    return '';
  };

  // Inbox convention: today shows the time, older messages show the date. Full timestamp on hover.
  const getLastMessageTime = (lastMessage) => {
    if (!lastMessage) {
      return '';
    }
    const sentToday = new Date(lastMessage.time).toDateString() === new Date().toDateString();
    return sentToday ? hourMinuteOnly(lastMessage.time) : formatDate(lastMessage.time);
  };

  const getName = () => conversationName(chat) || formatPhoneNumberForDisplay(chat.clientNumber)

  return (
    <div
      className={`gx-chat-user-item ${selectedChatId === chat._id ? 'active' : ''} ${isUnread ? 'unread' : ''}`}
      onClick={() => {onSelectUser(chat)}}
    >
      <div className="gx-chat-user-row">
        <div className="gx-chat-avatar">
          <div className="gx-status-pos">
            <MyAvatar
                number={chat.clientNumber}
                name={conversationName(chat)}
            />
            <span className={`gx-status gx-small gx-${chat.account}`}/>
          </div>
        </div>

        <div className="gx-chat-info">
          <span className="gx-name h4 gx-text-truncate" title={getName()}>{getName()}</span>
          <div className="gx-chat-info-des gx-text-truncate">{getLastMessageShort(chat.lastMessage)}</div>
          <div className="gx-last-message-time" title={chat.lastMessage ? formatTime(chat.lastMessage.time) : undefined}>{getLastMessageTime(chat.lastMessage)}</div>
        </div>

      </div>
    </div>
  )
};

export default UserCell;

UserCell.propTypes = {
  chat: PropTypes.any,
  isUnread: PropTypes.bool,
  onSelectUser: PropTypes.func,
  selectedChatId: PropTypes.string
};
